import { MQ_SMALL_ONLY, MQ_LARGE, MQ_XLARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base4x5, large4x5, medium4x5 } = IMAGE_SIZES;

const base = {
  fallbackDims: base4x5,
  sourceSets: [
    {
      layoutWidth: { value: 424, units: 'px' },
      imageDims: large4x5,
      media: MQ_XLARGE
    },
    {
      layoutWidth: { value: 310, units: 'px' },
      imageDims: medium4x5,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 224, units: 'px' },
      imageDims: medium4x5,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 200, units: 'px' },
      imageDims: medium4x5,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: '(min-width: 0px)',
      ratio: 4 / 5
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
